import Vue from "vue";
export const Eventbus = new Vue();
